import { resolve, define } from 'acast-www-utils';
import { getAllDescriptors } from './property-descriptor';

const states = new WeakMap();

function setState(schema, state) {
  states.set(schema, state);
}

function getState(schema) {
  return states.get(schema);
}

function getDefaultState(schema) {
  const descriptors = getAllDescriptors(schema) || {};
  const defaults = {};

  Object.keys(descriptors).forEach(key => {
    const descriptor = descriptors[key];
    let value = descriptor.default != null ? descriptor.default : null;

    if (typeof value === 'function') {
      value = value();
    }

    define(defaults, key, value);
  });

  return defaults;
}

function getComputedState(instance) {
  const descriptors = getAllDescriptors(instance.constructor);
  const output = getDefaultState(instance.constructor);
  const state = getState(instance);

  Object.keys(descriptors).forEach(key => {
    const descriptor = descriptors[key];
    const value = resolve(state, descriptor.path, output[key]);

    if (descriptor.validate(value)) {
      output[key] = value;
    }
  });

  return output;
}

export { getState, getDefaultState, getComputedState, setState };
